<div class="setting-container">
    <div class="header-row">
        <div class="header">
            <div class="empty-rect"></div>
            <div>
                {{ 'alarm-groups-settings.dialog.setting-header' | translate: { num: outputSetting.index } }}
            </div>
        </div>
        <ng-container *ngIf="outputSetting.index !== 1">
            <mat-icon class="close-icon" svgIcon="close" (click)="deleteSetting()" />
        </ng-container>
    </div>

    <div class="setting-option-row">
        <div class="setting-option-title">
            <div>
                {{ 'alarm-groups-settings.dialog.type.title' | translate }}
            </div>
            <div class="info-container">
                <mat-icon svgIcon="help" class="help-icon" />
                <div class="info-message-container">
                    <div class="option-container">
                        <span class="bold">
                            {{ 'alarm-groups-settings.dialog.type.info.one-shot.title' | translate }}
                        </span>
                        {{ 'alarm-groups-settings.dialog.type.info.one-shot' | translate }}
                    </div>
                    <br />
                    <div class="option-container">
                        <span class="bold">
                            {{ 'alarm-groups-settings.dialog.type.info.continuous.title' | translate }}
                        </span>
                        {{ 'alarm-groups-settings.dialog.type.info.continuous' | translate }}
                    </div>
                    <br />
                    <div class="option-container">
                        <span class="bold">
                            {{ 'alarm-groups-settings.dialog.type.info.flashing.title' | translate }}
                        </span>
                        {{ 'alarm-groups-settings.dialog.type.info.flashing' | translate }}
                    </div>
                    <br />
                    <div class="option-container">
                        <span class="bold">
                            {{ 'alarm-groups-settings.dialog.type.info.buzzer.title' | translate }}
                        </span>
                        {{ 'alarm-groups-settings.dialog.type.info.buzzer' | translate }}
                    </div>
                </div>
            </div>
        </div>
        <app-simple-dropdown
            style="flex: 1"
            [options]="TYPE_OPTIONS"
            [selectedOption]="outputSetting.type"
            (onOptionSelected)="handleTypeChanged($event)"></app-simple-dropdown>
    </div>

    <div class="setting-option-row">
        <div class="setting-option-title">
            <div>
                {{ 'alarm-groups-settings.dialog.mode.title' | translate }}
            </div>
        </div>
        <app-simple-dropdown
            style="flex: 1"
            [options]="MODE_OPTIONS"
            [selectedOption]="outputSetting.mode"
            (onOptionSelected)="handleModeChanged($event)"></app-simple-dropdown>
    </div>

    <ng-container *ngIf="isOneShot">
        <div class="setting-option-row">
            <div class="setting-option-title">
                <div>
                    {{ 'alarm-groups-settings.dialog.signal.title' | translate }}
                </div>
            </div>
            <app-simple-input
                style="flex: 1"
                [inputValue]="outputSetting.signal"
                [validatorFunction]="validatorFunction"
                [propertyName]="SIGNAL"
                placeholder="200~2000"
                [maxlength]="4"
                rightText="ms"
                [isNumberInput]="true"
                [errorIsAbsolute]="true"
                (onInputUpdated)="handleSignalChange($event)">
            </app-simple-input>
        </div>
    </ng-container>

    <div class="address-selectors-container" [class.disabledSelectors]="selectorsAreDisabled">
        <div>
            {{ 'alarm-groups-settings.dialog.address.title' | translate }}
        </div>
        <app-address-selectors
            class="address-selectors"
            [vesselSlots]="vesselSlots"
            [hasRowPadding]="false"
            [settingAddress]="outputSetting.address"
            (onSelectorChange)="handleSelectorsChange($event)">
        </app-address-selectors>
    </div>
</div>

<ng-template #selectorTemplate> </ng-template>
